import {  HandleApiModel } from '../../../api/targeting/model/targeting-search-result.api.model';
import { HandleTypeEnum } from '../../../api/targeting/enum/handle-type.enum';
import { EntityType } from '../../../api/targeting/enum/entity.type.enum';

export class HandleModel {

    handleType: HandleTypeEnum;
    value: string;
    primary: boolean;
    comment?: string;
    link?: string;
    editable: boolean;
    isPrivateData: boolean;
    preferred?: boolean;

    constructor(apiModel?: HandleApiModel, isPrivateData: boolean = false, entityType: EntityType = EntityType.CONTACT) {
        if (apiModel) {
            this.handleType = apiModel.handleType;
            this.value = apiModel.value;
            this.primary = apiModel.primary;
            this.comment = apiModel.comment;
            this.isPrivateData = isPrivateData;
            this.preferred = apiModel.preferred;
            this.setLink(entityType);
        }
        this.editable = true;
    }

    private setLink(entityType: EntityType): void {
        if (!this.value) {
            return;
        }

        // check if value is link already
        let url: URL;
        try {
            url = new URL(this.value);
        } catch (e) {}

        if (url) {
            this.link = this.value;
            return;
        }

        switch (this.handleType) {
            case HandleTypeEnum.EMAIL:
                this.link = `mailto:${this.value}`;
                break;
            case HandleTypeEnum.FACEBOOK:
                this.link = `https://facebook.com/${this.value}`;
                break;
            case HandleTypeEnum.INSTAGRAM:
                this.link = `https://instagram.com/${this.value}/`;
                break;
            case HandleTypeEnum.LINKEDIN:
                if (entityType === EntityType.OUTLET) {
                    this.link = `https://linkedin.com/company/${this.value}/`;
                } else {
                    this.link = `https://linkedin.com/in/${this.value}/`;
                }
                break;
            case HandleTypeEnum.TWITTER:
                this.link = `https://twitter.com/${this.value}`;
                break;
            case HandleTypeEnum.WEBSITE:
                this.link = this.value;
                break;
            case HandleTypeEnum.BLUESKY:
                this.link = `https://bsky.app/profile/${this.value}`;
                break;
            case HandleTypeEnum.TIKTOK:
                this.link = `https://www.tiktok.com/@${this.value}`;
                break;
            case HandleTypeEnum.YOUTUBE:
                this.link = `https://www.youtube.com/@${this.value}`;
                break;
            case HandleTypeEnum.PHONE:
            default:
                break;
        }
    }

    equals(other: HandleModel): boolean {
        return (
            this.handleType === other.handleType
            && this.value === other.value
            && this.preferred === other.preferred
            && this.primary === other.primary
        );
    }

    toApiModel() {
        return {
            handleType: this.handleType,
            value: this.value,
            primary: this.primary,
            comment: this.comment,
            preferred: this.preferred
        };
    }
}
